import { path } from 'ramda';
import { createSelector } from 'reselect';

export const getSkip = state => path(['notes', 'skip'], state);
export const getTotal = state => path(['notes', 'totalToDisplay'], state);
export const getEntities = state => path(['notes', 'entities'], state);
export const getNotes = createSelector(getEntities, entities => Object.values(entities));
export const getNoteById = id => createSelector(getEntities, entities => entities[id]);

export const getPendingNoteFetch = state => path(['notes', 'pendingFetch'], state);
export const getPendingNoteCreate = state => path(['notes', 'pendingCreate'], state);
export const getPendingNoteUpdate = state => path(['notes', 'pendingUpdate'], state);
export const getPendingNoteDelete = state => path(['notes', 'pendingDelete'], state);
export const getPendingNotes = state => ({
	fetch: getPendingNoteFetch(state),
	create: getPendingNoteCreate(state),
	update: getPendingNoteUpdate(state),
	delete: getPendingNoteDelete(state),
});

export const getDirtyNotes = state => path(['notes', 'isDirty'], state);

export const getNoteErrorFetch = state => path(['notes', 'fetchError'], state);
export const getNoteErrorCreate = state => path(['notes', 'createError'], state);
export const getNoteErrorUpdate = state => path(['notes', 'updateError'], state);
export const getNoteErrorDelete = state => path(['notes', 'deleteError'], state);
export const getNoteErrors = state => ({
	fetch: getNoteErrorFetch(state),
	create: getNoteErrorCreate(state),
	update: getNoteErrorUpdate(state),
	delete: getNoteErrorDelete(state),
});



// WEBPACK FOOTER //
// ./src/redux/notes/notes.selector.js